import { render, staticRenderFns } from "./Error_tbk.vue?vue&type=template&id=a521d77e&"
import script from "./Error_tbk.vue?vue&type=script&lang=js&"
export * from "./Error_tbk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports